export const config = {
    env: process.env.VUE_APP_ENV,
    serverUrl: process.env.VUE_APP_SERVER_URL,
    defaultLanguage: 'cz',

    authServer: {
        url: process.env.VUE_APP_AUTH_SERVER_URL,
        realm: process.env.VUE_APP_AUTH_REALM,
        clientId: 'touch_panel_master',
    },
};